import type { ActivateImporterAction, Importer } from '..';
import { ACTIVATE_IMPORTER } from '../actionTypes';

const activateImporter = (importer: Importer): ActivateImporterAction => ({
	type: ACTIVATE_IMPORTER,
	payload: importer,
});

export default activateImporter;
